require.context("../images", true);
require("@rails/ujs").start();
require("bootstrap");

require("@rails/activestorage").start();

require("jquery");
import I18n from "i18n-js";
window.I18n = I18n;

import "../libraries/jquery-ui";
import "../libraries/jquery-touch-punch";
import "../libraries/jquery.caret";
import "../libraries/autonumeric";
import "../libraries/select2";
import "../libraries/imodal";
import "../libraries/modals";

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

$(() => {
  $("#property_switcher").on("change", function (e) {
    window.location.href = e.target.value;
  });

  $(".max-exp-modal").show();

  var $deep_link = $("#_deep_link");
  if ($deep_link && $deep_link.length) {
    $deep_link.trigger("click");
  }
  /* admin nav toggle arrows */
  $(".page-sidebar .toggle-arrow").on("click", function () {
    var $arrow = $(this);
    var $a = $arrow.parent();
    var $ul = $arrow.parents("li").find("ul");

    if ($arrow.hasClass("arrow-down")) {
      $arrow.removeClass("arrow-down").addClass("arrow-right");
      $a.removeClass("expanded");
      $ul.hide("fast");
    } else {
      $arrow.removeClass("arrow-right").addClass("arrow-down");
      $a.addClass("expanded");
      $ul.show("fast");
    }

    return false;
  });

  /* sidebar scroll memory */
  var $pageSidebar = $(".page-sidebar");
  $pageSidebar.on("scroll", function (e) {
    localStorage.setItem("pageSidebarScroll", $pageSidebar.scrollTop());
  });
  $pageSidebar.scrollTop(localStorage.getItem("pageSidebarScroll") || 0);

  /* print functionality */
  $(document.body).on("click", ".print-new-window", function () {
    var $this = $(this);
    var win = window.open($this.data("url") || "/admin/print");

    win.onload = function () {
      $this.hide();
      win.pageContent =
        '<div class="print">' + $this.parent().html() + "</div>";
      win.init();
      $this.show();
    };
  });

  /* open links in a new window (when iframed, opens in top frame) */
  $(".open-new-window").on("click", function () {
    var win = window.top.open($(this).attr("href"), "_blank");
    win.focus();
    return false;
  });

  /* sidebar toggle */
  var $window = $(window),
    $navigation = $(".page-sidebar .navigation");

  $(".sidebar-toggle .btn").on("click", function (e) {
    if ($navigation.is(":visible")) {
      $navigation.slideUp("fast");
    } else {
      $navigation.slideDown("fast");
    }
  });

  $window.on("resize.sidebar", function () {
    if ($window.width() > 1024) {
      //$navigation.show();
      $(".data-table-actions")
        .find(".btn-group")
        .removeClass("btn-group-justified")
        .end()
        .find("#new_btn")
        .removeClass("btn-block");
    } else {
      //$navigation.hide();
      $(".data-table-actions")
        .find(".btn-group")
        .addClass("btn-group-justified")
        .end()
        .find("#new_btn")
        .addClass("btn-block");
    }
  });

  $window.trigger("resize");

  /* growl alerts */
  window.processGrowlAlerts = function () {
    $(".alert[data-growl]").each(function () {
      var $this = $(this);

      $.bootstrapGrowl($this.html(), { type: $this.data("type") });

      $this.remove();
    });

    window._attached_growl_alerts = true;
  };

  if (typeof window._attached_growl_alerts === "undefined") {
    window.processGrowlAlerts();
  }

  window.successGrowl = function (msg) {
    $.bootstrapGrowl(msg, { type: "success" });
  };

  // system notifications
  window.refreshSystemNotificationsBadgeNumber = function () {
    $.ajax({
      type: "POST",
      url: "/admin/system-notifications/badge-number",
    }).done(function (data) {
      if (data && data.badge_number && data.badge_number > 0) {
        $("#system-notifications-badge")
          .find(".badge")
          .html(data.badge_number)
          .end()
          .show();
      } else {
        $("#system-notifications-badge").hide();
      }
    });
  };

  window.refreshUnresolvedMessageIcon = function () {
    $.ajax({
      type: "POST",
      url: "/admin/messages/show_message_icon",
    }).done(function (data) {
      if (data.show_message_icon == false) {
        if (
          $("#unresolved-messages-icon") &&
          !Object.keys($("#unresolved-messages-icon")).length === 0
        ) {
          $("#unresolved-messages-icon").hide();
        } else {
          $(
            parent.window.document.getElementsByClassName(
              "unresolved-messages-icon"
            )[0]
          ).hide();
        }
      }
    });
  };

  // popover
  var showPopover = $.fn.popover.Constructor.prototype.show;
  $.fn.popover.Constructor.prototype.show = function () {
    showPopover.call(this);
    if ($(window).width() <= 658) {
      // mobile
      var $popover = $(".popover:visible");
      var $popover_clone = $popover.clone(true);

      $popover_clone.css({
        top: "50%",
        left: "50%",
        marginTop: "-" + $popover.outerHeight() / 2 + "px",
        marginLeft: "-" + $popover.outerWidth() / 2 + "px",
      });

      $popover.popover("hide");
      $(document.body).append($popover_clone);
    }
  };
  $(window).on("resize.hidePopovers", function () {
    setTimeout(function () {
      $(".popover").popover("hide");
    }, 0);
  });
  $(document.body).on("click", ".popover-close-wrapper button", function () {
    $(".popover:visible").remove();
  });

  // tooltips
  var is_touch_device =
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch);
  $(document.body)
    .tooltip({
      selector:
        '[title]:not(iframe, .featherlight-previous, .featherlight-next, .cke_editable, .cke_button, .sp-clear, .sp-thumb-el, [data-tooltip="off"], [data-toggle="popover"], [class^="select2"], .tox-button, .tox-tbtn, .tox-split-button)',
      delay: { show: 500, hide: 250 },
      container: "body",
      placement: function (_, element) {
        var $element = $(element);
        var offset = $element.offset();
        var height = $(document).outerHeight();
        var width = $(document).outerWidth();
        var vert = 0.5 * height - offset.top;
        var vertPlacement = vert > 0 ? "bottom" : "top";
        var horiz = 0.5 * width - offset.left;
        var horizPlacement = horiz > 0 ? "right" : "left";
        var placement = $element.data("placement")
          ? $element.data("placement")
          : Math.abs(horiz) > Math.abs(vert)
          ? horizPlacement
          : vertPlacement;
        return placement;
      },
      trigger: is_touch_device ? "click" : "hover",
      html: true,
    })
    .on("show.bs.tooltip", function (e) {
      setTimeout(function () {
        $(e.target).tooltip("hide");
      }, 10000);
      $(".tooltip").not(e.target).tooltip("hide");
    });

  /* prevent number input scroll */
  $("form").on("focus", "input[type=number]", function (e) {
    $(this).on("mousewheel.disableScroll", function (e) {
      e.preventDefault();
    });
  });

  $("form").on("blur", "input[type=number]", function (e) {
    $(this).off("mousewheel.disableScroll");
  });

  /* helpers */
  window.removeSeason = function (ele) {
    var $season = $(ele).parent();
    $season
      .find("[title]")
      .tooltip("destroy")
      .end()
      .hide("drop", function () {
        $season.remove();
      });
  };

  window.remove_fields = function remove_fields(ele) {
    $(ele)
      .find("[title]")
      .tooltip("destroy")
      .end()
      .parents(".fields")
      .find("input[type=hidden]")
      .val(1)
      .end()
      .hide("drop");
  };

  window.add_fields = function add_fields(link, association, content) {
    var new_id = new Date().getTime(),
      regexp = new RegExp("new_" + association, "g"),
      $form = $(link).parents("form"),
      $actions = $form.find(".form-actions"),
      $wrapper = $("#" + association + "_wrapper").length
        ? $("#" + association + "_wrapper")
        : $($actions.attr("data-wrapper"));

    if ($actions.is(":hidden")) {
      $actions.show();
      $form.find(".none").remove();
    }

    if ($wrapper.length == 0) {
      $actions.before(content.replace(regexp, new_id));
    } else {
      $wrapper.prepend(content.replace(regexp, new_id));
    }

    //animate so user can see item
    var $first_child = $wrapper.children().first();
    $first_child.effect("highlight");
  };

  //disable autocomplete on all inputs
  if (document.getElementsByTagName) {
    var inputElements = document.getElementsByTagName("input");
    for (var i = 0; inputElements[i]; i++) {
      if (!inputElements[i].autocomplete) {
        inputElements[i].setAttribute("autocomplete", "off");
      }
    }
  }
});
